import {Component, OnInit, signal} from '@angular/core';
import {TwoFactorService} from '../../services/two-factor.service';
import {Router, RouterLink} from '@angular/router';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {AuthenticationService} from '../../services/auth/authentication.service';
import {CodaltComponent} from '../../codalt.component';
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";
import {MatError, MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {DecimalInputDirective} from "../../directives/decimal-input.directive";
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-two-factor',
    templateUrl: './two-factor.component.html',
    styleUrls: ['./two-factor.component.scss'],
    imports: [
        VvrIconComponent,
        MatFormField,
        MatLabel,
        MatError,
        FormsModule,
        MatInput,
        DecimalInputDirective,
        RouterLink,
        MatButton
    ]
})
export class TwoFactorComponent extends CodaltComponent implements OnInit {

    readonly validating = signal<boolean>(false);
    private readonly _twoFactorCode = signal('');

    constructor(
        private twoFactorService: TwoFactorService,
        private confirmDialog: ConfirmDialogService,
        private authService: AuthenticationService,
        private router: Router
    ) {
        super();
    }

    // Getter and setter for ngModel two-way binding
    get twoFactorCode(): string {
        return this._twoFactorCode();
    }

    set twoFactorCode(value: string) {
        this._twoFactorCode.set(value);
    }


    ngOnInit(): void {
    }

    login() {
        this.validating.set(true);
        this.twoFactorService.validate(`${this._twoFactorCode()}`.replace(/\s/g, '')).subscribe(() => {
            this.authService.refresh().subscribe(() => {
                this.validating.set(false);
                this.router.navigate(['/']);
            });
        }, error => {
            this.validating.set(false);
            this.confirmDialog.confirm('Er ging iets fout', error.message);
        });
    }

}
